var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"nordea-logo",attrs:{"src":"https://templates.kvass.no/custom-pm-1/assets/nordea.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }